import React, { FC, useEffect } from 'react';
import classNames from 'classnames';

let activeScrollLocks = 0;

const lockBodyScroll = () => {
  activeScrollLocks += 1;
  document.body.classList.add('hidden_scroll');
};

const unlockBodyScroll = () => {
  activeScrollLocks = Math.max(0, activeScrollLocks - 1);
  if (activeScrollLocks === 0) {
    document.body.classList.remove('hidden_scroll');
  }
};

export const ModalWrap: FC<{
  isShow: boolean;
  children: React.ReactNode;
  className?: string;
  onBackdropClick?: () => void;
}> = ({ isShow = false, children, className, onBackdropClick }) => {
  useEffect(() => {
    if (!isShow) {
      return;
    }

    lockBodyScroll();
    return unlockBodyScroll;
  }, [isShow]);

  if (!isShow) {
    return null;
  }

  return (
    <div
      className={classNames(
        'w-full h-full fixed bottom-0 top-0 right-0 left-0 z-modal bg-ink/60 backdrop-blur-[1px] flex items-center justify-center p-[15px]',
        className,
      )}
      // mousedown, not click: a text selection dragged out of the window must not close it.
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onBackdropClick?.();
      }}
    >
      {children}
    </div>
  );
};
